function PageWrapper({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`px-6 py-4 relative overflow-x-hidden overflow-y-auto h-full w-[calc(100vw-240px)]  ${className}`}
    >
      {children}
    </div>
  );
}

export default PageWrapper;
